
import React from 'react';

const LandingHeader = () => {
  return (
    <div className="text-center">
      <img 
        src="/lovable-uploads/29f5a874-3103-490e-ae29-e107bf621df9.png" 
        alt="Company Logo" 
        className="mx-auto h-16 w-auto"
      />
      <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
        Welcome
      </h1>
      <p className="mt-2 text-sm text-gray-600">
        Please enter your details to access our product catalog
      </p>
    </div>
  );
};

export default LandingHeader;
